import React, { useEffect, useState } from 'react'
import Header from '../../Components/Header'
import Footer from '../../Components/Footer'
import './home.css'
import { Col, Container, Row, Carousel, Button, Card } from 'react-bootstrap'
import banner from '../../assets/banner.webp'
import banner1 from '../../assets/slider/banner-1.webp'
import banner2 from '../../assets/slider/banner-2.webp'
import banner3 from '../../assets/slider/banner-3.webp'
import banner4 from '../../assets/slider/banner-4.webp'
import mac from '../../assets/Screen-time-to-BAAI.webp'
import artificial from '../../assets/artificial-intelligence.webp'
// import logo1 from '../../assets/logo/image-1.png'
import qualcomm from '../../assets/logo/Qualcomm.png'
// import logo3 from '../../assets/logo/3.svg'
import yourstory from '../../assets/logo/Yourstory.png'
import imgform from '../../assets/Frame8674.webp'
// import star from '../../assets/star.png'
import JoinWaitListForm from '../../Components/Rewards/JoinWaitList/JoinWaitListForm'
import { Link, useParams } from 'react-router-dom'
// import { message } from 'antd'

const Home = () => {
  const [activeIndex, setActiveIndex] = useState(0)
  const { referralId } = useParams()

  useEffect(() => {
    if (referralId) {
      let ele = document.getElementById('join-form')
      setTimeout(() => {
        ele.scrollIntoView({ behavior: 'smooth', block:'center' })
      }, 2000)
    }
  }, [referralId])

  return (
    <div>
      <Header />
      <Container
        fluid
        className="custom-black px-0"
      >
        <Container className="pb-5">
          <Row className=" heading">
            <Col lg={12}>
              <p>World's First Engagement AI</p>
              <h1>
                <span>Boost</span> Engagement <span>| Get </span> Rewarded
              </h1>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col lg={12}>
              <Card>
                <img
                  src={banner}
                  width="1115"
                  height="491"
                  alt="logo"
                  className="img-fluid w-100"
                  style={{ borderRadius: '5px' }}
                  // loading="lazy"
                />
              </Card>
            </Col>
          </Row>
        </Container>
      </Container>
      <Container
        fluid
        className="px-0 bg-dark-graph "
        id="about"
      >
        <Container>
          <Row className="align-items-center">
            <Col lg={4}>
              <h2>BAAI</h2>
            </Col>
            <Col lg={8}>
              <p>BrainAlive AI (BAAI) is an AI Engine that leverages data transformation approach to convert raw interaction data into real-time user engagement insights.</p>
            </Col>
          </Row>
        </Container>
      </Container>
      <Container
        fluid
        className="px-0 slider_home"
        id="product"
      >
        <Carousel data-bs-theme="dark">
          <Carousel.Item>
            <img
              className="d-block img-fluid w-100"
              src={banner1}
              alt="First slide"
              width="1435"
              height="758"
              loading="lazy"
            />
            <Carousel.Caption>
              <Container>
                <Row className="caption_slide  align-item-center">
                  <Col
                    lg={10}
                    xs={9}
                    className="text-start"
                  >
                    {' '}
                    <h3>BA3E</h3>
                    <p>Peek into your brain activity.!</p>
                    <p>BA3E gives you a peek into your brain activity thereby enabling you to discover and develop new habits that would help you blaze through your day.</p>
                  </Col>{' '}
                  {/* <Button variant="light">know more</Button> */}
                </Row>
              </Container>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <img
              className="d-block img-fluid w-100"
              src={banner4}
              alt="Second slide"
              loading="lazy"
              width="1435"
              height="758"
            />
            <Carousel.Caption>
              <Container>
                <Row className="caption_slide  align-item-center">
                  <Col
                    lg={10}
                    xs={9}
                    className="text-start"
                  >
                    {' '}
                    <h3>FOCII</h3>
                    <p>Discover what keeps your audience engaged.!</p>
                    <p>Get to know what is keeping your audience engaged.</p>
                  </Col>{' '}
                  {/* <Button variant="light">know more</Button> */}
                </Row>
              </Container>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <img
              className="d-block img-fluid w-100"
              src={banner3}
              alt="Third slide"
              width="1435"
              height="758"
              loading="lazy"
            />
            <Carousel.Caption>
              <Container>
                <Row className="caption_slide  align-item-center">
                  <Col
                    lg={10}
                    xs={9}
                    className="text-start"
                  >
                    {' '}
                    <h3>BA9E</h3>
                    <p>Gather, Analyze & Conclude. Explore beyond your physical self..!</p>
                    <p>Monitor brain signals using our state of the art EEG research headset that comes with convenient software packages, and take a deep dive into exploring what lies beyond your physical self.</p>
                  </Col>{' '}
                  {/* <Button variant="light">know more</Button> */}
                </Row>
              </Container>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <img
              className="d-block img-fluid w-100"
              src={banner2}
              alt="Third slide"
              loading="lazy"
              width="1435"
              height="758"
            />
            <Carousel.Caption>
              <Container>
                <Row className="caption_slide  align-item-center">
                  <Col
                    lg={10}
                    xs={9}
                    className="text-start"
                  >
                    {' '}
                    <h3>ABHA</h3>
                    <p>Quicker Stroke Recovery.</p>
                    <p>
                      Our active stroke rehabilitation therapy involves the user's brain during the therapy to help achieve a better and quicker recovery. ABHA monitors your brain signals using EEG and captures the imagination of your motor movement to enable an upper limb exoskeleton in assisting
                      the mobility when the mental imagination is right.
                    </p>
                  </Col>{' '}
                  {/* <Button variant="light">know more</Button> */}
                </Row>
              </Container>
            </Carousel.Caption>
          </Carousel.Item>
        </Carousel>
      </Container>
      <Container
        fluid
        className="px-0 custom-black pb-5 pt-6"
        id="science"
      >
        <Container>
          <Card className="bg_1">
            <Row>
              <Col lg={9}>
                <div>
                  {' '}
                  <img
                    src={mac}
                    alt="logo"
                    className="img-fluid"
                    loading="lazy"
                    width="256"
                    height="205"
                  />
                </div>

                <div style={{ position: 'relative' }}>
                  <h4>Turn screen time to earn time with BAAI</h4>
                  {/* <div className="star">
                    <img
                      src={star}
                      alt="logo"
                    />
                  </div> */}
                </div>
                <p>Start earning while you connect, scroll, watch, and chat!</p>
              </Col>

              <Button
                variant="dark"
                className="a-btn"
              >
                <Link
                  to="/rewards"
                  className="text-decoration-none text-light"
                >
                  Explore
                </Link>
              </Button>
            </Row>
          </Card>
          <Card className="bg_1 bg_2 mt-4">
            <Row>
              <Col lg={9}>
                <div>
                  {' '}
                  <img
                    src={artificial}
                    width="130"
                    height="130"
                    alt="logo"
                    className="img-fluid"
                    loading="lazy"
                  />
                </div>

                <h4>Science</h4>
                <p>Understand the science behind our products.</p>
              </Col>

              <Button
                variant="dark"
                className="a-btn"
              >
                <Link
                  to="/science"
                  className="text-decoration-none text-light"
                  aria-label="learn more"
                >
                  Learn More
                </Link>
              </Button>
            </Row>
          </Card>
        </Container>
      </Container>
      <Container
        fluid
        className="px-0 bg-light-black"
      >
        <Container
          fluid
          className="px-0 slider_testimonial"
        >
          <Carousel
            onSelect={e => setActiveIndex(e)}
            indicators={false}
            activeIndex={activeIndex}
            data-bs-theme="dark"
          >
            {/* <Carousel.Item>
              <Container>
                <Row>
                  <Col
                    lg={11}
                    className="m-auto sec-text"
                  >
                    <p>“Abbas Mehdi and Gaurav Dubey’s BrainAlive aims to improve user engagement in online learning/webinars/meeting through detecting, reasoning and determining the causality of user engagement using data-driven innovative tech.”</p>
                    <h5 className="text-end">-nasscom</h5>
                  </Col>
                </Row>
              </Container>
            </Carousel.Item> */}
            <Carousel.Item>
              <Container>
                <Row>
                  <Col
                    lg={11}
                    className="m-auto sec-text"
                  >
                    <Link
                      to="https://www.qualcomm.com/company/locations/india/design-in-india-program/design-in-india-challenge#2022"
                      target="_blank"
                      className="text-decoration-none"
                    >
                      {' '}
                      <p>“BrainAlive aims to improve user engagement in online learning/webinars/meetings through detecting, reasoning, and determining the causality of user engagement using data-driven innovative tech.”</p>
                    </Link>
                    <h5 className="text-end">-Qualcomm Design in India Challenge (QDIC)</h5>
                  </Col>
                </Row>
              </Container>
            </Carousel.Item>
            {/* <Carousel.Item>
              <Container>
                <Row>
                  <Col
                    lg={11}
                    className="m-auto sec-text"
                  >
                    <p>“Abbas Mehdi and Gaurav Dubey’s BrainAlive aims to improve user engagement in online learning/webinars/meeting through detecting, reasoning and determining the causality of user engagement using data-driven innovative tech.”</p>
                    <h5 className="text-end">-GITEX global</h5>
                  </Col>
                </Row>
              </Container>
            </Carousel.Item> */}
            <Carousel.Item>
              <Container>
                <Row>
                  <Col
                    lg={11}
                    className="m-auto sec-text"
                  >
                    <Link
                      to="https://yourstory.com/video/indian-deep-tech-story"
                      target="_blank"
                      className="text-decoration-none"
                    >
                      <p>“BrainAlive’s AI-based virtual assistant has the power of sight and the mind of a human to accurately track user engagement and provide powerful insights.”</p>
                    </Link>
                    <h5 className="text-end">-Yourstory TV</h5>
                  </Col>
                </Row>
              </Container>
            </Carousel.Item>
          </Carousel>
        </Container>
        <Container>
          <Row className="d-flex justify-content-center text-center mt-4 align-items-center">
            {/* <Col
              lg={3}
              xs={3}
            >
              <div
                className={activeIndex === 0 ? 'active-feedback feedback' : 'feedback'}
                onClick={() => setActiveIndex(0)}
              >
                {' '}
                <img
                  src={logo1}
                  alt="logo"
                  className="img-fluid"
                />
              </div>
            </Col> */}
            <Col
              lg={3}
              xs={3}
            >
              {/* <div
                className={activeIndex === 1 ? 'active-feedback feedback' : 'feedback'}
                onClick={() => setActiveIndex(1)}
              > */}
              <div
                className={activeIndex === 0 ? 'active-feedback' : ''}
                onClick={() => setActiveIndex(0)}
              >
                <img
                  src={qualcomm}
                  alt="logo"
                  className="img-fluid"
                  loading="lazy"
                  width="261"
                  height="67"
                />
              </div>
            </Col>
            {/* <Col
              lg={3}
              xs={3}
            >
              <div
                className={activeIndex === 2 ? 'active-feedback' : ''}
                onClick={() => setActiveIndex(2)}
              >
                {' '}
                <img
                  src={logo3}
                  alt="logo"
                  className="img-fluid"
                />
              </div>
            </Col> */}
            <Col
              lg={3}
              xs={3}
            >
              {/* <div
                className={activeIndex === 3 ? 'active-feedback' : ''}
                onClick={() => setActiveIndex(3)}
              > */}
              <div
                className={activeIndex === 1 ? 'active-feedback' : ''}
                onClick={() => setActiveIndex(1)}
              >
                {' '}
                <img
                  src={yourstory}
                  alt="logo"
                  className="img-fluid"
                  loading="lazy"
                  width="261"
                  height="67"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </Container>
      <Container
        fluid
        className="px-0 custom-black pt-4 pb-4"
        id="join"
      >
        <Container>
          <div className="bg_form_g">
            <Row className="py-3 align-items-center">
              <Col lg={7}>
                {' '}
                <img
                  src={imgform}
                  width="641"
                  height="565"
                  alt="logo"
                  className="img-fluid"
                  loading="lazy"
                />
              </Col>
              <JoinWaitListForm />
            </Row>
          </div>
        </Container>
      </Container>
      <Footer />
    </div>
  )
}

export default Home
